import { Icon } from 'Components/shared/Icon';
import styled from 'styled-components';

const MutedIcon = styled(Icon).attrs(() => ({
  icon: 'muted',
}))`
  margin-left: 10px;
`;

export const Styled = {
  MutedIcon,
};
